exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ng-select{\n     background-color: #fff\n }\n:host >>> .select2-container--default{\n    width: auto !important\n} ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/logs/log-scan.component.css
// module id = ../../../../../src/app/pages/admin/evs/logs/log-scan.component.css
// module chunks = 3